import React from 'react'

import { observer } from 'mobx-react-lite'
import { Redirect } from 'wouter'

import { Loader } from '#components/Loader'
import {
  showRedeemErrorAlert,
  useRedeemPromotionCode,
} from '#components/Onboarding/redeemPromotionCode'
import { useMst } from '#state'
import { ROUTE_PATTERNS } from '#util/pathConfigs'

const Redeem = ({ code }: { code: string }) => {
  const { user } = useMst()
  const { mutate, isPending } = useRedeemPromotionCode()
  const started = React.useRef(false)

  React.useEffect(() => {
    if (started.current) return
    started.current = true

    const next =
      user.orgMemberships.length === 0
        ? ROUTE_PATTERNS.createWorkspace
        : ROUTE_PATTERNS.root

    mutate(code, {
      async onSettled(_data, error) {
        if (error) await showRedeemErrorAlert(error)
        window.location.replace(next)
      },
    })
  }, [mutate, user, code])

  return <Loader visible={isPending} fullScreen />
}

export const RedeemRoute = observer(() => {
  const { location, loggedIn } = useMst()
  const code = location.getQueryParam('code')

  if (!code) {
    return (
      <Redirect to={loggedIn ? ROUTE_PATTERNS.root : ROUTE_PATTERNS.login} />
    )
  }

  if (!loggedIn) {
    const returnTo = encodeURIComponent(location.pathname + location.search)
    return (
      <Redirect to={`${ROUTE_PATTERNS.createAccount}?returnTo=${returnTo}`} />
    )
  }

  return <Redeem code={code} />
})
